import React from "react"
import { Spacer } from "../atoms/Atoms"
import { Body } from "../atoms/Bodies"
import L10n from "../../../lib/carrot-l10n"
import { H2 } from "@carrotfertility/carotene"
const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const MerchantDeclineError = () => (
  <>
    <Spacer height={2} />
    <H2 variant="primary">{l`We're working on your request`}</H2>
    <Spacer height={1} />
    <Body>{l`Unfortunately your request is taking longer than expected. We’ll send you an SMS as soon as the provider is approved. `}</Body>
    <Spacer height={1} />
  </>
)
